var render = function render(){var _vm=this,_c=_vm._self._c;return _c('News',{attrs:{"code":"gang","leftTitle":"推荐信息"}})
}
var staticRenderFns = []

export { render, staticRenderFns }